import Index from "views/Index.js";

import Login from "views/examples/Login.js";
import Tables from "views/examples/Tables.js";
import Createstage from "views/examples/createstage";
import Userlist from "views/examples/Userlist";
import Referrals from "views/examples/Referrals";
import Bonuses from "views/examples/bonuses";
import AdminUserManagement from "views/examples/AdminUserManagement";
import Notifications from "views/examples/Notifications";
import TwitterPosts from "views/examples/TwitterPosts";
import TreasuryActivity from "views/examples/TreasuryActivity";
import TreasuryReserve from "views/examples/TreasuryReserve";

import FormList from "views/examples/FormList";
import Blockuser from "views/examples/Blockuser";
import Table from "views/examples/usdtClaim";
var routes = [
  {
    path: "/index",
    name: "Dashboard",
    icon: "ni ni-chart-bar-32 text-#FFB000",
    component: <Index />,
    layout: "/admin",
  },
  // {
  //   path: "/icons",
  //   name: "Icons",
  //   icon: "ni ni-planet text-blue",
  //   component: <Icons />,
  //   layout: "/admin",
  // },
  // {
  //   path: "/maps",
  //   name: "Maps",
  //   icon: "ni ni-pin-3 text-orange",
  //   component: <Maps />,
  //   layout: "/admin",
  // },
  {
    path: "/ucreatestage",
    name: "Create Stage",
    icon: "ni ni-pin-3 text-yellow",
    component: <Createstage />,
    layout: "/admin",
  },
  {
    path: "/bonuses",
    name: "Create Bonuses",
    icon: "ni ni-laptop text-yellow",
    component: <Bonuses />,
    layout: "/admin",
  },
  {
    path: "/user-list",
    name: "User List",
    icon: "ni ni-single-02 text-yellow",
    component: <Userlist />,
    layout: "/admin",
  },
  {
    path: "/FormList",
    name: "Form Status",
    icon: "ni ni-collection text-yellow",
    component: <FormList />,
    layout: "/admin",
  },
  {
    path: "/blockuser",
    name: "User Status",
    icon: "ni ni-key-25 text-yellow",
    component: <Blockuser />,
    layout: "/admin",
  },
  {
    path: "/transactionlist",
    name: "Transactions",
    icon: "ni ni-bullet-list-67 text-yellow",
    component: <Tables />,
    layout: "/admin",
  },
  {
    path: "/referrals",
    name: "Referrals",
    icon: "ni ni-ui-04 text-yellow",
    component: <Referrals />,
    layout: "/admin",
  },
  {
    path: "/usdtClaim",
    name: "usdtClaim",
    icon: "ni ni-ui-04 text-yellow",
    component: <Table />,
    layout: "/admin",
  },
  {
    path: "/admin-users",
    name: "Admin Users",
    icon: "ni ni-user-run text-red",
    component: <AdminUserManagement />,
    layout: "/admin",
  },
  {
    path: "/notifications",
    name: "Notifications",
    icon: "ni ni-notification-70 text-yellow",
    component: <Notifications />,
    layout: "/admin",
  },
  {
    path: "/twitter-posts",
    name: "Twitter Posts",
    icon: "ni ni-world text-yellow",
    component: <TwitterPosts />,
    layout: "/admin",
  },
  {
    path: "/wallet-activity",
    name: "Wallet Activity",
    icon: "ni ni-credit-card text-yellow",
    component: <TreasuryActivity />,
    layout: "/admin",
  },
  {
    path: "/treasury-reserve",
    name: "Treasury Reserve",
    icon: "ni ni-money-coins text-yellow",
    component: <TreasuryReserve />,
    layout: "/admin",
  },
  // {
  //   path: "/merge",
  //   name: "Merged Transaction",
  //   icon: "ni ni-credit-card text-yellow",
  //   component: <MergedTranx />,
  //   layout: "/admin",
  // },
  {
    path: "/login",
    name: "Login",
    icon: "ni ni-lock-circle-open text-yellow",
    component: <Login />,
    layout: "/auth",
  },
];
export default routes;
